import axios from "axios";
import { END_FREE_TRIAL } from "../utils";

export const endFreeTrial = async () => {
  return await axios.post(END_FREE_TRIAL);
};
